import { Quiz2 } from './quiz'

export type LoadingPhase = 'none' | 'loading' | 'loaded';

export const QuizQuerySymbol = Symbol.for('QuizQuery')

export interface QuizQuery {
  quizzes: Quiz2[]
  loadingPhase: LoadingPhase
}
